/* eslint-disable arrow-body-style */
import { Box, Button, CircularProgress, Grid2, Typography } from '@mui/material';
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { getCheckoutByIdGql } from '../gql';
import Tracking from '../../../components/Tracking';

export default function SuccessSummary({ details }) {
  const params = useParams();

  const { data, loading } = useQuery(getCheckoutByIdGql, {
    variables: {
      slug: params.slug,
      externalId: params.externalId,
    },
  });

  // eslint-disable-next-line no-unused-vars
  const checkout = useMemo(() => data?.getCheckoutById, [data?.getCheckoutById]);

  if (loading) {
    return (
      <Grid2 sx={{ width: '100%', textAlign: 'center', minHeight: '200px' }}>
        <CircularProgress />
      </Grid2>
    );
  }

  return (
    <Box
      sx={{
        p: 4,
        maxWidth: 800,
        mx: 'auto',
        bgcolor: 'background.paper',
        borderRadius: 2,
        boxShadow: 3,
      }}
    >
      <Typography variant="h4" gutterBottom sx={{ textAlign: 'center', marginBottom: 3 }}>
        Vielen Dank für Ihre Bestellung
      </Typography>
      <Typography variant="subtitle1" gutterBottom>
        Ihre Bestellnummer lautet <b>{checkout?.orderNumber}</b>. Wir haben Ihnen die Bestellbestätigung per E-Mail zugesandt.
      </Typography>
      <Typography variant="subtitle1">
        Die Tickets werden nach Zahlungseingang per E-Mail versendet.
        Bitte prüfen Sie auch Ihren Spam-Ordner, falls Sie keine E-Mail erhalten.
      </Typography>
      <Box sx={{ marginTop: 2, textAlign: 'center' }}>
        <Button href={`/${params.slug}/checkout`} variant="contained">Weitere Bestellung aufgeben</Button>
      </Box>
      <Tracking details={details} checkout={checkout} />
    </Box>
  );
}
